import TableDynamic from "../../components/TableDynamic";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { store } from "../../reducer/Store";
import ApiService from "../../services/ApiService";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import PrestatairesModal from "../../components/prestataires/PrestatairesModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const Prestataires = () => {
  const { dispatch, state } = React.useContext(store);
  const [name, setName] = React.useState([]);
  const [showAdd, setShowAdd] = React.useState(false);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [image, setImage] = React.useState();
  const [errorFormatFile, setErrorFormatFile] = React.useState(false);
  const [warningTooSmall, setWarningTooSmall] = React.useState(false);
  const [errorNotASquare, setErrorNotASquare] = React.useState(false);
  const [errorHeavyFile, setErrorHeavyFile] = React.useState(false);
  const [idPrestataire, setIdPrestataire] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const columnsName = ["Prestataires", "Logo/Pastille", ""];
  const columns = ["name", "image", "updateAndDelete"];

  const handleShowAdd = () => setShowAdd(true);
  const handleShowUpdate = (data) => {
    setIdPrestataire(data.id);
    setName(data.name);
    setShowUpdate(true);
  };

  const handleClose = () => {
    setErrorFormatFile(false);
    setErrorNotASquare(false);
    setWarningTooSmall(false);
    setErrorHeavyFile(false);
    setShowAdd(false);
    setShowUpdate(false);
    setErrorMessage("");
    setIdPrestataire("");
    setImage();
    setName([]);
  };

  /**
   * Cette fonction permet de récupérer la liste des prestataires à partir de l'API et de les assigner à l'état de l'application.
   */
  const getPrestataires = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    try {
      ApiService.request(
        {},
        `providers-by-year/${state.currentYear.value}`,
        "get"
      )
        .then(function (response) {
          dispatch({ type: "SET_LISTPRESTATAIRES", payload: response.data });
          //console.log(response.data);
          dispatch({ type: "SET_LOADER", payload: false });
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    } catch (error) {
      dispatch({ type: "SET_LOADER", payload: false });
      console.log(error.message);
    }
  };

  /**
   * Cette fonction gère l'enregistrement d'un nouveau prestataire et utilise ApiService pour effectuer une requête POST avec les informations du prestataire.
   * @param { string } img - L'image du prestataire à enregistrer.
   * @param { Number } name - Le nom de l'image du prestataire.
   * @param { Number } year_id - L'année à laquelle rattacher le prestataire.
   */
  const registerPrestataires = async (img) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name,
        image: img,
        year_id: state.currentYear.value,
      },
      "providers",
      "post"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        getPrestataires();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà.");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour un prestataire existant dans la base de données en envoyant une requête HTTP de type PUT avec les données à mettre à jour.
   * @param { File } img - Le fichier image du prestataire.
   * @param { Number } name - Le nom de l'image du prestataire.
   * @param { Number } year_id - L'année à laquelle rattacher le prestataire.
   * @param { Number } idPrestataire - L'ID du prestataire.
   */
  const updatePrestataires = async (img) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name,
        image: img,
        year_id: state.currentYear.value,
      },
      `providers/${idPrestataire}`,
      "put"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        getPrestataires();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        if (error.response.data.message.includes("already exists.")) {
          setErrorMessage("Ce nom est déjà utilisé.");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime un prestataire.
   * Elle demande d'abord une confirmation à l'utilisateur avant d'envoyer une requête de suppression au serveur.
   * Si la requête est réussie, elle appelle la fonction getPrestataires() pour rafraîchir la liste des prestataires affichée.
   * Si une erreur se produit, elle affiche un message dans la console et gère l'erreur d'authentification en vidant le local storage et déconnectant l'utilisateur.
   * @param {Object} prestataire - L'objet du prestataire à supprimer
   * @return {void}
   */
  const deletePrestataire = (prestataire) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer le visuel de la marque " +
        prestataire.name +
        " ?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "providers/" + prestataire.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getPrestataires();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Gère le changement d'image du profil utilisateur
   * @param {Event} event - L'événement de changement d'image
   * @return {void}
   */
  const handleImageChange = (event) => {
    setErrorFormatFile(false);
    setErrorNotASquare(false);
    setWarningTooSmall(false);
    setErrorHeavyFile(false);
    const selectedFile = event.target.files[0];
    if (
      selectedFile.type !== "image/jpeg" &&
      selectedFile.type !== "image/png"
    ) {
      setErrorFormatFile(true);
    }
    setImage(selectedFile);
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width !== img.height) {
          setErrorNotASquare(true);
        }
        if (img.width !== 200 || img.height !== 200) {
          setWarningTooSmall(true);
        }
      };
      if (selectedFile.size > 5000000) {
        setErrorHeavyFile(true);
      }
      img.src = e.target.result;
    };
    reader.readAsDataURL(selectedFile);
  };

  React.useEffect(() => {
    getPrestataires();
  }, [state.currentYear]);

  return (
    <>
      <h1>
        Prestataires
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleShowAdd}>
              <AddCircleOutlineOutlinedIcon /> Ajouter
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>
      {showAdd && (
        <PrestatairesModal
          handleClose={handleClose}
          show={showAdd}
          image={image}
          addOrUpdatePrestataire={registerPrestataires}
          handleImageChange={handleImageChange}
          setImage={setImage}
          errorMessage={errorMessage}
          name={name}
          setName={setName}
          errorHeavyFile={errorHeavyFile}
          errorNotASquare={errorNotASquare}
          errorFormatFile={errorFormatFile}
          warningTooSmall={warningTooSmall}
          nameModal={"Ajouter"}
        />

      )}
      {showUpdate && (
        <PrestatairesModal
          handleClose={handleClose}
          show={showUpdate}
          image={image}
          addOrUpdatePrestataire={updatePrestataires}
          handleImageChange={handleImageChange}
          setImage={setImage}
          errorMessage={errorMessage}
          name={name}
          setName={setName}
          errorHeavyFile={errorHeavyFile}
          errorNotASquare={errorNotASquare}
          errorFormatFile={errorFormatFile}
          warningTooSmall={warningTooSmall}
          nameModal={"Ajouter"}
        />

      )}
      <TableDynamic
        columnsName={columnsName}
        columns={columns}
        data={state.listPrestataires}
        showUpdate={handleShowUpdate}
        deleteD={deletePrestataire}
      ></TableDynamic>
    </>
  );
};

export default Prestataires;